import { Theme } from '@mui/material/styles';
import { createStyles, makeStyles } from '@mui/styles';
import { sideBarWidth } from '../../constant/sidebar.constant';

const useDismissibleSnackbarStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            right: 0,
            padding: theme.spacing(0, 3),
            [theme.breakpoints.down('xs')]: {
                left: 0,
            },
        },
        contentWidth: {
            [theme.breakpoints.up('sm')]: {
                width: `calc(100% - ${sideBarWidth}px)`,
            },
            [theme.breakpoints.down('sm')]: {
                width: '100%',
            },
        },
        fullWidth: {
            width: `100%`,
        },
        alertRoot: {
            width: '100%',
            padding: 0,
            minHeight: '76px',
        },
        alertAction: {
            paddingRight: theme.spacing(3),
            marginRight: 0,
            flexDirection: 'column',
            justifyContent: 'center',
        },
        message: {
            textAlign: 'center',
            marginLeft: theme.spacing(5),
            justifyContent: 'center',
            display: 'flex',
            alignItems: 'center',
        },
        alertMessage: {
            width: '100%',
        },
        errorMessage: {
            width: 'auto',
        },
        retry: {
            color: 'white',
            borderColor: 'white',
            marginRight: theme.spacing(2),
        },
        iconButton: {
            alignItem: 'center',
        },
    }),
);

export default useDismissibleSnackbarStyles;
